import React from 'react'

import ImgIx from '../../components/imgix-img'

interface ImageProps {
  src: string
  variant: 'small' | 'medium' | 'large' | 'xlarge'
  alt: string
  critical: boolean
}

export const Image: React.FC<ImageProps> = ({ variant, src, alt, critical = false }) => {
  const sizeMap = {
    small: 293,
    medium: 341,
    large: 439,
  }
  return (
    <ImgIx
      className={`image image__${variant}`}
      src={src}
      width={sizeMap[variant]}
      alt={alt}
      critical={critical}
    />
  )
}

interface AuthorImageProps {
  src: string
  variant: 'small' | 'large'
}

export const AuthorImage: React.FC<AuthorImageProps> = ({ src, variant }) => {
  return (
    <ImgIx
      className={`author-image author-image__${variant}`}
      src={src}
      width={112}
      alt='Author image'
      critical={false}
    />
  )
}

interface ProviderImageProps {
  src: string
  alt: string
  critical: boolean
  variant: 'xsmall' | 'small' | 'large'
}

export const ProviderImage: React.FC<ProviderImageProps> = ({
  src,
  alt,
  variant,
  critical = false,
}) => {
  const sizeMap = {
    xsmall: 120,
    small: 140,
    large: 180,
  }
  return (
    <ImgIx
      className={`provider-image provider-image__${variant}`}
      src={src}
      width={sizeMap[variant]}
      alt={alt}
      critical={critical}
    />
  )
}
